import moment from 'moment';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import formDataPostService from '../../../services/httpformData';
import html2PDF from 'jspdf-html2canvas';
import React, { Component } from 'react';
import { Upload, Modal, Tooltip, Button, Spin, Divider, Checkbox } from 'antd';
import Storage from '../../../services/local-store';
import userTrackService from '../../../services/usertrack-service';
import { PDFDocument } from 'pdf-lib';
import {EMAIL} from './../../../constants/app-constants';

let dollarIndianLocale = Intl.NumberFormat('en-IN');
const { base_url } = networkList;
class PatientInsuranceAcknowledgement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'loadding': false,
            'showDocument': false,
            patientDocument: [],
            body: [],
            tbody: [],
            thead: [{
                "key": 'document_description',
                'label': 'Corporate'
            },{
                "key": 's_no',
                'label': ''
            },{
                "key": 'document_description',
                'label': 'Retail/Individual'
            },  {
                "key": 's_no',
                'label': ''
            }, ],
            fileList:[],
            disable_15days: false,
            latest_counselling_id: null,
            current_counselling_id: null,
            uploadedFiles: Array(5).fill(null),
            description:Array.from({ length: 5 }, () => []),
            autoFilledFileList : []
        }
    }
    async componentDidMount() {
        const { id, slug } = this.props.match.params;
        // await this.initial();
        this.setState({tbody:this.props.tbody,body:this.props.body})
        await this.getPatientDocumentDetails();
        await this.patInsuranceSubmissionAck();
    }
    initial() {
        // this.getMasterDocumentTypes();
        console.log("initial");
        const { id, slug } = this.props.match.params
        if (slug === 'patients-history-details') {
            let yes = this.props.mydata
            if (yes) {
                let { unit_id, umr_no, ip_no } = this.props.mydata
                if (umr_no) {
                    this.setState({ showDocument: true, hideonHistory: true, ui_form_type: 'view' });
                    this.getPatientDocumentDetails();
                } else {
                    this.setState({ showDocument: false, hideonHistory: true, ui_form_type: 'view' })
                }
            }
        } if (slug === 'pending-docs') {
            let yes = this.props.mydata
            if (yes) {
                let { unit_id, umr_no, ip_no } = this.props.mydata
                if (umr_no) {
                    this.setState({ showDocument: true, hideonHistory: true, ui_form_type: 'view' });
                    this.getPatientDocumentDetails();
                } else {
                    this.setState({ showDocument: false, hideonHistory: true, ui_form_type: 'view' })
                }
            }
        }
        if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
            let tokenData = JSON.parse(Storage.get('current_token'));
            if (tokenData && tokenData['umr']) {
                this.setState({ showDocument: true, ui_form_type: 'add' });
                this.getPatientDocumentDetails();
            } else {
                this.setState({ showDocument: false, ui_form_type: 'add' })
            }
        }
        if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
            let view = JSON.parse(Storage.get('counselling_view'));
            if (view && view[0]['umr']) {
                this.setState({ showDocument: true, ui_form_type: 'view' });
                this.getPatientDocumentDetails();
            } else {
                this.setState({ showDocument: false, ui_form_type: 'view' })
            }
        }
        if (slug === 'pre-auth-worklist' ) {
            let yes = this.props.mydata
            if (yes) {
                let { unit_id, umr_no, ip_no } = this.props.mydata
                if (umr_no) {
                    this.setState({ showDocument: true, hideonHistory: true, ui_form_type: 'view' });
                    this.getPatientDocumentDetails();
                } else {
                    this.setState({ showDocument: false, hideonHistory: true, ui_form_type: 'view' })
                }
            }
        }
    }
    // getMasterDocumentTypes() {
    //     this.setState({ loadding: true })
    //     console.log("getMasterDocumentTypes");
    //     let { getMasterDocumentTypes } = networkList;
    //     try {
    //         postService(getMasterDocumentTypes, 'GET', {}).then(res => {
    //             if (res['status']) {
    //                 this.setState((state) => ({ 'tbody': res['data'] }));
    //                 this.setState({ loadding: false })                
    //                 Storage.store('getMasterDocumentTypes', res['data']);
    //                 this.getPatientDocumentDetails();
    //             } else {
    //                 this.setState((state) => ({ 'docTypes': [] }));
    //                 this.setState({ loadding: false })
    //             }
    //         });
    //     } catch (error) {
    //         console.log(error);
    //         this.setState((state) => ({ 'loadding': false }));
    //         Modal.error({
    //             title: 'Error Message',
    //             content: 'Oops, Something is wrong. Please try again.',
    //         })

    //     }
    // }
    getPatientDocumentDetails() {
        this.setState({ loadding: true })
        let { getUploadPatientsDocumentsDetails } = networkList;
        const { id, slug } = this.props.match.params;
        let tokenData = JSON.parse(Storage.get('current_token'));
        let user_data = JSON.parse(Storage.get('user_data'));
        let view = JSON.parse(Storage.get('counselling_view'));
        let payload = {}
        if (slug === 'patients-history-details') {
            let yes = this.props.mydata ? this.props.mydata : false
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': counselling_id })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        if (slug === 'pending-docs') {
            let yes = this.props.mydata ? this.props.mydata : false
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': parseInt(counselling_id) })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        if (slug === 'pre-auth-worklist') {
            let yes = this.props.mydata ? this.props.mydata : false
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': counselling_id })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        // add counselling
        if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
            payload = { "umr_no": tokenData['umr'], "ip_no": tokenData['ip'] || null, "unit_id": user_data['unitid'], "form_type": "add", "counselling_id": '' || null }
            this.setState({ "umr_no": tokenData['umr'], "ip_no": tokenData['ip'], "patient_name": tokenData['patient_name'], ui_form_type: 'add' })
        }
        // view counselling
        if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
            const params = new URLSearchParams(this.props.location.search);
            let ui_counselling_id = params.get('cid');
            let current_counselling_id = this.props.print_counselling_id || ui_counselling_id || '';
            let disable_15days = null
            if (view && view[0]['counselling_date']) {
                var days = Math.abs((moment(view[0]['counselling_date']).diff(moment(new Date()), 'day')));
                disable_15days = days > 15 ? true : false
            } else {
                disable_15days = false
            }
            payload = { "umr_no": view[0]['umr'], "ip_no": view[0]['ip_no'], "unit_id": user_data['unitid'], "form_type": "view", "counselling_id": current_counselling_id }
            this.setState({ "umr_no": view[0]['umr'], "ip_no": view[0]['ip_no'], "patient_name": view[0]['patient_name'], 'disable_15days': disable_15days, ui_form_type: 'view','current_counselling_id': current_counselling_id })
        }
        try {
            const Userlogobj ={
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "get Patient Document Details - Request",
                    "date": new Date(),
                    "meta": payload
                }
            }
            userTrackService(Userlogobj);
            postService(getUploadPatientsDocumentsDetails, 'POST', { "data": payload }).then(res => {
                const Userlogobjres ={
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "get Patient Document Details - Response",
                        "date": new Date(),
                        "meta": res
                    }
                }
                userTrackService(Userlogobjres);
                if (res['status']) {
                    let latest_cou_id = res['latest_counselling_id'] ? res['latest_counselling_id'] : null;

                    this.setState((state) => ({ 'patientDocument': res['data'],'latest_counselling_id': latest_cou_id }));
                    this.setState({ loadding: false });
                    Storage.store('getPatientDocumentDetails', res['data']);
                } else {
                    this.setState((state) => ({ 'patientDocument': [] }));
                    this.setState({ loadding: false })
                }
            });
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })

        }
    }
    patInsuranceSubmissionAck() {
        let {umr,umr_no,patient_name,ip_no} = this.props;

        const counsellingID = Math.floor(100000 + Math.random() * 900000);
        let This=this
        const tableHeadData = `patInsuranceSubmissionAck`;
        const patientChecklistPreview = document.getElementById(tableHeadData);
        if (patientChecklistPreview !== null && patientChecklistPreview !== '' && patientChecklistPreview !== undefined){
            // html2PDF(patientChecklistPreview,{
                const pdfConfig = {
                image: { type: 'png', quality: 0.20 },
                jsPDF: { format: 'a4' },
                html2canvas: {
                    scrollX: 0,
                    scrollY: -window.scrollY,
                    useCORS: true,
                },
                theme: 'plain',
                styles: {
                    fontSize: 4,
                    cellPadding: 0.75,
                    lineColor: [200, 200, 200],
                    lineWidth: 0.1,
                    valign: 'middle',
                    halign: 'center',
                    fillColor: [255, 255, 255],
                },
                margin: { top: 40, right: 20, bottom: 40, left: 20 },
                imageType: 'image/jpeg',
                output: './images/generate_checklist.pdf',
                success: function (pdf) {
                    const blob = pdf.output('blob');
                    const form_data = new FormData();
                    form_data.append('upfileforpatInsuranceSubmissionAck', blob);
                    form_data.append('umr', (umr || umr_no));
                    form_data.append('patient_name', patient_name);
                    form_data.append('ip', ip_no);
                    // form_data.append('phone_no', digiSignPhone);
                    formDataPostService('patInsuranceSubmissionAck', 'POST', form_data).then(res => {
                        if (res.status) {
                            localStorage.setItem('completed_counselling_date', moment());
                            // This.props.next();
                            // This.setState({ loadding: false });
                        }
                    });
                }
            };
            html2PDF(patientChecklistPreview, pdfConfig);
            // }); 
        }
    }

    render() {
        let { tbody, showDocument, patientDocument, thead, umr_no, ip_no, fileList, loadding, hideonHistory, ui_form_type, disable_15days, current_counselling_id, latest_counselling_id } = this.state;
        const { patient_name } = this.props;
        const pat_doc_ids = patientDocument && patientDocument.length > 0 ? patientDocument[0].documentId.map(doc => parseInt(doc.documentid)) : [];
        // Update tbody items to set checked and disabled status
        this.props.tbody.forEach(item => {
            if (pat_doc_ids.includes(item.id)) {
                item.checked = true; // Autofill checkbox
                if (!this.props.body.find(doc => doc.id === item.id)) {
                    this.props.body.push({ id: item.id, document_description: item.document_description, document_short_code: item.document_short_code, document_type: item.document_type, upload_type: item.upload_type, is_mandatory: item.is_mandatory }); // Add to state.body if not already present
                }
                item.disabled = true;
            } else {
                item.disabled = false;
            }
        });
        let filteredTbody = this.props.tbody.filter(item => item.is_mandatory === 1 || this.props.body.some(doc => doc.id === item.id));
        const { id, slug } = this.props.match.params;
        let user_data;
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'));
        }
        let unit = [];
        if (localStorage.getItem('all_user_data') !== null) {
            let unitData = JSON.parse(localStorage.getItem('all_user_data'));
            unit = unitData.map(data => ({ unit_id: data.unitid, unit_name: data.unit_name, display_name: data.display_name }));
        }
        let unitName;
        if (user_data && user_data["unitid"]) {
            for (let i = 0; i < unit.length; i++) {
                if (unit[i].unit_id === user_data["unitid"]) {
                    unitName = unit[i].display_name;
                    break;
                }
            }
        }
        let displayIndex = 0;
        return (
            <div id='patInsuranceSubmissionAck'>
                <React.Fragment>
                    <div className='fc-patient-copy'>
                        <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn" style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', marginBottom: '20px' }}>
                                <div>
                                    <img src={`/assets/images/units-logo/${user_data["unitid"] && user_data["unitid"]}.png`} alt="Kims" style={{ width: '200px', height: 'auto' }} />
                                </div>
                            </div>
                            <div className="financial-table table-responsive pop-table" style={{ textAlign: 'center', marginTop: '20px' }}>
                                <h2 style={{ textDecoration: 'underline' }}>Insurance documents submission acknowledgement</h2>
                            </div>
                            <div style={{ marginTop: '30px' }}>
                                <p> Dear {patient_name ? patient_name : '--'},</p>
                                <p>We acknowledge receipt of the following documents towards your insurance claim submission:</p>
                                <table style={{ borderCollapse: 'collapse', textAlign: 'center', marginTop: '10px' }} className="table table-hover table-bordered mb-0 bg-white">
                                    <thead style={{ backgroundColor: '#084b69' }}>
                                        <tr>
                                            <th colSpan="3" style={{ border: '1px solid black', padding: '8px' }}>Insurance documents checklist</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredTbody.length > 0 && filteredTbody.map((item, index) => {
                                            displayIndex++;
                                            return (
                                                <tr key={index} className={`${!pat_doc_ids.includes(item.id) ? 'tb-blocked' : ''} ${ui_form_type === 'view' && disable_15days ? 'tb-blocked' : ''}`}>
                                                    <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>{displayIndex}</th>
                                                    <th style={{ border: '1px solid black', padding: '8px' }}>{item.document_description ? item.document_description + (item.is_mandatory ? ' *' : '') : "--"}</th>
                                                    <th style={{ border: '1px solid black', padding: '8px' }}>
                                                        <input
                                                            style={{ padding: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                            type="checkbox"
                                                            checked={this.props.body && this.props.body.some(doc => doc.id === item.id)}
                                                            // disabled={item.disabled}
                                                        />
                                                    </th>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            <div style={{ marginTop: '20px' }}>
                                <p className="one text-justify">Please submit the pending documents at the earliest to speed up your insurance claim request process. You may submit the hard copies to our executive or e-mail soft copies to us at {EMAIL[user_data["unitid"]]}</p>
                                <p className="one text-justify">Our insurance team will reach out to you on your registered mobile numbers if there are any deficiencies in the required documents to submit your claim request. Your cooperation is highly appreciated!</p>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                                <div style={{ textAlign: 'left' }}>
                                    <p>{user_data["username"]}</p>
                                    <p>Admissions department</p>
                                    <p>KIMS Hospital</p>
                                    <p>{unitName}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            </div>
        );
    }
}

export default PatientInsuranceAcknowledgement;